const initRegions = (requestPrograms, status, field) => {
  const link = "https://2025.api.tgu-dpo.ru/regions/GetRegions";
  let regionsList = [];

  /* Инициализация поля регионы */
  /* Добавление всех возможных регионов доступных программ */

  if (status == "online") { 
    async function initRegionsOnline() {
      try {
        let response = await fetch(link),
          result = await response.json();
  
        function addRegionsSelect(id) {
          let regionsSelect = $(id);
          regionsSelect.html('').select2();
  
          result.forEach(function (el) {
            let selected = false,
              option = new Option(el.name, el.id, false, selected);
  
            option.accessKey = el.id;
            regionsSelect.append(option);
          });
  
          regionsSelect.val(null);
          regionsSelect.select2({
            placeholder: "Ваш регион",
          });
        }
  
        addRegionsSelect(`#${field}`);
      } catch (e) {
        console.log(e);
      }
    }
    initRegionsOnline();
  } else {  
    requestPrograms.forEach((item) => {
      item.regions.forEach((region) => {
        if (region.cities && region.cities.length > 0) {
          let data = {};
          data.regionId = region.regionId;
          data.regionName = region.regionName;
  
          regionsList.push(data);
        } else {
          let data = {};
          data.regionId = region.regionId;
          data.regionName = region.regionName;
  
          regionsList.push(data);
        }
      });
    });
  
    /* Удаление дублей регионов */
    const filterRegions = regionsList.filter(
      (obj, idx, array) =>
        idx === array.findIndex((t) => t.regionId === obj.regionId)
    );
  
    /* Инициализация поля Регионы */
    initRegionsOffline(filterRegions);
  
    /* Добавление регионов в форму */
    function initRegionsOffline(regions) {
      function addRegionsSelect(id) {
        let regionsSelect = $(id);
        regionsSelect.html('').select2();
  
        regions.forEach(function (el) {
          let selected = false,
            option = new Option(el.regionName, el.regionId, false, selected);
  
          option.accessKey = el.regionId;
          regionsSelect.append(option);
        });
  
        regionsSelect.val(null);
        regionsSelect.select2({
          placeholder: "Ваш регион",
        });
      }
  
      addRegionsSelect(`#${field}`);
    }
  }  
};

export default initRegions;
